<template>
  <div>
    <div v-for="(item, index) in items" :key="index" class="bills__text">
      <b-card v-if="item.items"
              no-body
              class="mb-1 border-0">
        <b-card-header
            header-tag="header"
            class="pointer border-0 bills__expand"
            role="tab"
            v-b-toggle="'bill-' + item.label.replaceAll(' ', '-') + index">
          <div class="d-flex justify-content-between align-items-center">
            <div>{{item.label}}<i class="fas fa-sort-down ml-2"></i></div>
            <div class="font-weight-normal">{{item.price}}</div>
          </div>
        </b-card-header>
        <b-collapse :id="'bill-' + item.label.replaceAll(' ', '-') + index">
          <b-card-body class="position-relative d-flex flex-column pb-0 bills__expand">
            <bill-expand class="pl-4 mt-2" :items="item.items"/>
          </b-card-body>
        </b-collapse>
      </b-card>
      <div v-else class="bills__info mb-3">
        <div class="d-flex justify-content-between align-items-center">
          <div>{{item.label}}</div>
          <div>{{item.price}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default  {
  name: 'BillExpand',
  props: {
    items: {
      type: Array,
      default: () => []
    }
  }
}
</script>